import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import UserItem from './UserItem';
import UserService from '../../../Services/userService';

class SetTimesheetUserWindowDescription extends React.Component {
  static titleForCreate = 'Select the Timesheet User';
  static titleForEdit = 'Select the Timesheet User';
  static ComponentName = '';
  static itemType = UserItem;
  static serviceFunction = UserService.SaveTimesheetUser;

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'TimesheetUserUserName',
          label: 'Timesheet User',
          className: 'col-12',
          type: InputTypesEnum.TimesheetUserListSelect,
          validityChecker: ValidityHelper.emptyValidityChecker,
        },
      ],
    },
  ];
}

export default SetTimesheetUserWindowDescription;
